import { QuestionImage } from '../question-image';

export enum ContentItemTypeEnum {
  Text = 'text',
  Image = 'image',
  Table = 'table',
}

export interface TextContentItem {
  type: ContentItemTypeEnum.Text;
  content: string;
}

export interface TableContentItem {
  type: ContentItemTypeEnum.Table;
  content: string; // Just the table HTML/markdown content
  description?: string;
  title?: string;
  style?: Partial<CSSStyleDeclaration>;
  container_width?: string; // Width percentage for flex container layout (e.g., "50%", "75%", "100%")
  fill_in_the_blanks?: boolean;
}

export type ImageContentItem = QuestionImage & {
  type: ContentItemTypeEnum.Image;
  fill_in_the_blanks?: boolean;
};

export type ContentItem = TextContentItem | ImageContentItem | TableContentItem;
